export default __webpack_public_path__ + "static/media/gallery_15.a9d52ba3.jpg";